import { getAppName, getDefaultLogo } from "@/utils/utils";
import { Layout } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import itgoLogo from "../../../assets/images/logo-itgo-transparent.png";
import { AppName } from "../../../common/constants";
import styles from "./Footer.module.scss";

export const Footer = () => {
  const { t } = useTranslation();

  const appName = getAppName();

  return (
    <Layout.Footer className={styles.footer}>
      <div className={styles.footerWrapper}>
        <div className={styles.logoWrapper}>
          <div className={styles.footerText}>Powered by</div>
          <img className={styles.footerCompanyLogo} src={itgoLogo} alt="itgo logo" />
        </div>
        <div className={styles.footerInfo}>
          {appName === AppName.CLIIP ? (
            <span>
              <strong>cliip</strong> -{" "}
              <span>
                <strong>C</strong>lient <strong>L</strong>oan <strong>I</strong>nsurance <strong>I</strong>nvestment{" "}
                <strong>P</strong>ortal
              </span>
            </span>
          ) : (
            <span>
              <span>PROF</span>
              <strong>IT</strong>
            </span>
          )}
          {t("common.copyright", { year: dayjs().year() })}
        </div>
        <div className={styles.logoWrapper}>
          <img className={styles.footerAppLogo} src={getDefaultLogo("square")} alt="App logo" />
        </div>
      </div>
    </Layout.Footer>
  );
};
